import React from 'react'
import styled from 'styled-components'
import NotFound from '../../assets/images/not-found.jpg'

const BackgroundDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 60px;
`

const StyledImage = styled.img`
  font-size: 28px;
  position: relative;
  top: 100px;
`

const NotFoundPage = () => (
  <div>
    <BackgroundDiv>
      <StyledImage src={NotFound} alt="Construction" height="500" width="500" />
    </BackgroundDiv>
  </div>
)

export default NotFoundPage
